import { render, staticRenderFns } from "./StoreProductHiddenField.vue?vue&type=template&id=254c03df&"
import script from "./StoreProductHiddenField.vue?vue&type=script&lang=js&"
export * from "./StoreProductHiddenField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports